
import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { pathname } = useLocation();
  const isResumePage = pathname === "/resume";

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="flex flex-col min-h-screen bg-[#FFFFFF]">
      <Navbar />
      <main className={`flex-grow ${isResumePage ? "" : "pt-20 md:pt-24"}`}>{children}</main>
    </div>
  );
}
